import axios from "axios";

export default function assignTicket({ id, assigneeId, assigneeName }) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/support/api/v1/admin/tickets/${id}/assign`, {
        assignee_id: assigneeId,
        assignee_name: assigneeName,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
